module.exports = __webpack_public_path__ + "img/mes_ar.cfab2fb1.png";